import { Carousel } from 'primereact/carousel'
import React from 'react'
import './index.scss'
import fallbackImage from '../../../assets/images/FallbackImage.jpg'
import LoadingAnimation from '../../LoadingAnimation/LoadingAnimation' 
import { useTranslation } from "react-i18next";

const NewsCard = ({ articles, alerts, isLoading }) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

	const responsiveOptions = [
		{
			breakpoint: '1024px',
			numVisible: 3,
			numScroll: 3,
		},
		{
			breakpoint: '992px',
			numVisible: 1,
			numScroll: 1,
		}
	]
    const redirectToReadMore = (evnt, article, alerts) => {
		evnt.stopPropagation()
		article && window.open(article.pageUrl, '_blank')
	}

	const formatDate = (dateString) => {
		return new Date(dateString).toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
		});
		};
	

		const articleTemplate = (article) => {
			return (
				<div
					className='card-content'
					onClick={(e) => redirectToReadMore(e, article)}
				>
					<div
						className='card-content__img'
						style={{
							backgroundImage: `url(${article?.imageUrl || fallbackImage})`
						}}
					>
						<img
							src={article?.imageUrl || fallbackImage}
							onError={(e) => {
								e.target.onerror = null; 
								e.target.src = fallbackImage;
							}}
							alt={article?.heading || 'News image'}
						/>
					</div>
		
					<div className='card-content__text'>
						<div className='card-content__datesection'>
							{formatDate(article.date)}
						</div>
		
						{article.heading && !(article.heading.includes('Alert')) && (
							<div className='card-content__heading'>
								<div className='section-sub-heading mb-0'>{article.heading}</div>
							</div>
						)}
		
						{article.heading?.includes('Alert') && (
							<div className='card-content__alertheading mb-3'>
								<div className='section-sub-alertheading mb-0'>{article.heading}</div>
							</div>
						)}
		
						{article.description && (
							<div className='card-content__description'>
								<div className='news-description'>{article.description}</div>
							</div>
						)}
		
						<div className='card-content__link'>
							<button
								type='button'
								className='secondary-button learn-more-button'
								onClick={(e) => redirectToReadMore(e, article)}
							>
								{t('COMMON.LEARN_MORE')}
							</button>
						</div>
					</div>
				</div>
			);
		};
		
		return (
			<div className={`carousel-wrapper ${isRTL ? 'rtl' : ''}`}>
				<div className='carousel-container'>
					{isLoading ? (
						<div className='loading-container'>
							<LoadingAnimation />
						</div>
					) : (
						articles &&
						articles.length > 0 && (
							<Carousel
								value={articles}
								itemTemplate={articleTemplate}
								numVisible={3}
								numScroll={1}
								responsiveOptions={responsiveOptions}
								circular
								autoplayInterval={4000}
							/>
						)
					)}
				</div>
			</div>
		)
}
export default NewsCard
